function initNewslettersPage(cards, selectAllBtn, clearBtn, bar, countEl, typesInput, closeBtn) {
  let selected = [];
  const form = typesInput.closest('form');
  const submitBtn = form ? form.querySelector('[type="submit"]') : null;
  const feedbackEl = form ? form.querySelector('[data-nl-feedback]') : null;
  const chipsEl = document.getElementById('nlBottomChips');
  const toolbarCountEl = document.getElementById('nlPageToolbarCount');
  const toolbarSepEl = document.getElementById('nlPageToolbarSep');
  const successEl = bar.querySelector('[data-nl-page-success]');
  const successEmailEl = bar.querySelector('[data-nl-page-success-email]');
  const successCloseBtn = bar.querySelector('[data-nl-page-success-close]');
  const emailInput = form ? form.querySelector('[name="email"]') : null;
  const originalBtnText = submitBtn ? submitBtn.textContent : '';
  let isSuccess = false;
  let submittedEmail = '';

  function getCardData(card) {
    return {
      key: card.getAttribute('data-nl'),
      name: card.getAttribute('data-nl-name') || card.querySelector('.nl-page-card-name').textContent,
      frequency: card.getAttribute('data-nl-frequency') || ''
    };
  }

  function updateBar() {
    const count = selected.length;
    typesInput.value = selected.map(function (item) {
      return item.key;
    }).join(',');
    bar.classList.toggle('is-success', isSuccess);
    if (successEl) successEl.hidden = !isSuccess;
    if (successEmailEl) successEmailEl.textContent = submittedEmail;
    countEl.textContent = count + (count === 1 ? ' newsletter selected' : ' newsletters selected');
    if (toolbarCountEl) {
      toolbarCountEl.textContent = count + ' selected';
      toolbarCountEl.hidden = count === 0;
    }
    if (toolbarSepEl) toolbarSepEl.hidden = count === 0;
    if (count > 0) {
      bar.classList.add('is-visible');
      if (feedbackEl) {
        feedbackEl.textContent = '';
        feedbackEl.removeAttribute('data-state');
      }
    } else {
      bar.classList.remove('is-visible');
    }
    if (submitBtn) submitBtn.disabled = count === 0;
    selectAllBtn.classList.toggle('all-selected', count === cards.length);
    if (clearBtn) {
      clearBtn.disabled = count === 0;
      clearBtn.hidden = count === 0;
    }

    if (chipsEl) {
      chipsEl.innerHTML = '';
      selected.forEach(function (item) {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'nl-bottom-chip';
        chip.setAttribute('aria-label', 'Remove ' + item.name);
        chip.innerHTML = '<span aria-hidden="true"></span>' + item.name + '<b aria-hidden="true">×</b>';
        chip.addEventListener('click', function () {
          const card = Array.from(cards).find(function (c) {
            return c.getAttribute('data-nl') === item.key;
          });
          if (card) {
            selectCard(card, false);
            updateBar();
          }
        });
        chipsEl.appendChild(chip);
      });
    }
  }

  function selectCard(card, on) {
    const item = getCardData(card);
    card.setAttribute('data-selected', on ? 'true' : 'false');
    card.querySelectorAll('[data-nl-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + item.name);
    });
    if (on && !selected.some(function (s) {
      return s.key === item.key;
    })) {
      selected.push(item);
    } else if (!on) {
      selected = selected.filter(function (s) {
        return s.key !== item.key;
      });
    }
  }

  cards.forEach(function (card) {
    card.querySelectorAll('[data-nl-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        isSuccess = false;
        const isSelected = card.getAttribute('data-selected') === 'true';
        selectCard(card, !isSelected);
        updateBar();
      });
    });

    card.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      isSuccess = false;
      const isSelected = card.getAttribute('data-selected') === 'true';
      selectCard(card, !isSelected);
      updateBar();
    });
  });

  selectAllBtn.addEventListener('click', function () {
    isSuccess = false;
    cards.forEach(function (card) {
      selectCard(card, true);
    });
    updateBar();
  });

  function clearSelection() {
    isSuccess = false;
    submittedEmail = '';
    cards.forEach(function (card) {
      selectCard(card, false);
    });
    selected = [];
    updateBar();
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', clearSelection);
  }

  if (form) {
    form.addEventListener('submit', function () {
      submittedEmail = emailInput ? emailInput.value.trim() : '';
    });
  }

  if (successCloseBtn) {
    successCloseBtn.addEventListener('click', clearSelection);
  }

  closeBtn.addEventListener('click', function () {
    clearSelection();
  });

  if (form) form.addEventListener('nl:subscribed', function () {
    isSuccess = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = originalBtnText;
    }
    updateBar();
  });

  updateBar();
}

function initNewsletterBanner(cards, typesInput, hint, submitBtn) {
  let selected = [];
  const form = typesInput.closest('form');
  const widget = form ? form.closest('[data-nl-home]') : null;
  const mainEl = widget ? widget.querySelector('[data-nl-main]') : null;
  const contentEls = widget ? widget.querySelectorAll('[data-nl-content]') : [];
  const selectedEl = widget ? widget.querySelector('[data-nl-selected]') : null;
  const emptyEl = widget ? widget.querySelector('[data-nl-empty]') : null;
  const statusEl = widget ? widget.querySelector('[data-nl-status]') : null;
  const fieldsEl = form ? form.querySelector('.nl-form-fields') : null;
  const emailInput = form ? form.querySelector('[name="email"]') : null;
  const feedbackEl = form ? form.querySelector('[data-nl-feedback]') : null;
  const successEl = widget ? widget.querySelector('[data-nl-success]') : null;
  const successEmailEl = widget ? widget.querySelector('[data-nl-success-email]') : null;
  const successListEl = widget ? widget.querySelector('[data-nl-success-list]') : null;
  const originalBtnText = submitBtn.textContent;
  let lastEmail = '';

  function getCardData(card) {
    return {
      key: card.getAttribute('data-nl'),
      name: card.getAttribute('data-nl-name') || card.querySelector('.nl-card-name').textContent,
      frequency: card.getAttribute('data-nl-frequency') || ''
    };
  }

  function renderSelected() {
    typesInput.value = selected.map(function (item) {
      return item.key;
    }).join(',');
    submitBtn.disabled = selected.length === 0;
    if (emailInput) emailInput.disabled = selected.length === 0;

    if (selected.length === 0) {
      hint.textContent = 'Pick at least one';
      hint.classList.remove('has-selection');
      if (statusEl) {
        statusEl.textContent = 'Select at least one dispatch above.';
        statusEl.classList.remove('is-error');
      }
      if (selectedEl && emptyEl) {
        selectedEl.innerHTML = '';
        selectedEl.appendChild(emptyEl);
        emptyEl.hidden = false;
      }
      return;
    }

    hint.textContent = selected.length + (selected.length === 1 ? ' dispatch selected' : ' dispatches selected');
    hint.classList.add('has-selection');
    if (statusEl) {
      statusEl.textContent = 'No spam ever. Unsubscribe in one click any time.';
      statusEl.classList.remove('is-error');
    }

    if (!selectedEl) return;

    selectedEl.innerHTML = '';
    selected.forEach(function (item) {
      const chip = document.createElement('span');
      chip.className = 'nl-chip';

      const dot = document.createElement('span');
      dot.className = 'nl-chip-dot';
      dot.setAttribute('aria-hidden', 'true');

      const name = document.createElement('span');
      name.textContent = item.name;

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'nl-chip-remove';
      remove.setAttribute('aria-label', 'Remove ' + item.name);
      remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M6 18L18 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
      remove.addEventListener('click', function () {
        selectCard(item.key, false);
      });

      chip.appendChild(dot);
      chip.appendChild(name);
      chip.appendChild(remove);
      selectedEl.appendChild(chip);
    });
  }

  function selectCard(key, on) {
    const card = Array.from(cards).find(function (c) {
      return c.getAttribute('data-nl') === key;
    });
    if (!card) return;

    const alreadySelected = selected.some(function (item) {
      return item.key === key;
    });
    if (on && !alreadySelected) {
      selected.push(getCardData(card));
      card.setAttribute('data-selected', 'true');
    } else if (!on && alreadySelected) {
      selected = selected.filter(function (item) {
        return item.key !== key;
      });
      card.setAttribute('data-selected', 'false');
    }

    if (fieldsEl) fieldsEl.classList.remove('is-error');
    if (feedbackEl) {
      feedbackEl.textContent = '';
      feedbackEl.removeAttribute('data-state');
    }
    renderSelected();
  }

  function reset() {
    selected = [];
    typesInput.value = '';
    submitBtn.disabled = true;
    submitBtn.textContent = originalBtnText;
    submitBtn.classList.remove('is-submitting');
    if (emailInput) emailInput.disabled = true;
    if (fieldsEl) fieldsEl.classList.remove('is-error');
    cards.forEach(function (c) {
      c.setAttribute('data-selected', 'false');
    });
    renderSelected();
  }

  function showSuccess() {
    if (!successEl || !mainEl) {
      reset();
      return;
    }

    if (feedbackEl) {
      feedbackEl.textContent = '';
      feedbackEl.removeAttribute('data-state');
    }

    if (successEmailEl) successEmailEl.textContent = lastEmail;
    if (successListEl) {
      successListEl.innerHTML = '';
      selected.forEach(function (item) {
        const row = document.createElement('div');
        row.className = 'nl-success-item';

        const dot = document.createElement('span');
        dot.className = 'nl-success-dot';
        dot.setAttribute('aria-hidden', 'true');

        const name = document.createElement('span');
        name.textContent = item.name;

        row.appendChild(dot);
        row.appendChild(name);

        if (item.frequency) {
          const frequency = document.createElement('span');
          frequency.className = 'nl-success-item-frequency';
          frequency.textContent = item.frequency;
          row.appendChild(frequency);
        }

        successListEl.appendChild(row);
      });
    }

    widget.classList.add('is-success');
    contentEls.forEach(function (el) {
      el.classList.add('nl-content--hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    successEl.hidden = false;
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      const key = card.getAttribute('data-nl');
      const pressed = card.getAttribute('data-selected') === 'true';

      selectCard(key, !pressed);
    });
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      lastEmail = emailInput ? emailInput.value.trim() : '';
      if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(lastEmail)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        submitBtn.classList.remove('is-submitting');
        if (fieldsEl) fieldsEl.classList.add('is-error');
        if (statusEl) {
          statusEl.textContent = lastEmail === '' ? 'Email is required!' : "That doesn't look like a valid email. Mind double-checking?";
          statusEl.classList.add('is-error');
        }
        emailInput.focus();
        return;
      }
      if (selected.length === 0) return;
      submitBtn.classList.add('is-submitting');
      if (statusEl) {
        statusEl.textContent = 'Sending dispatch confirmation...';
        statusEl.classList.remove('is-error');
      }
      if (fieldsEl) fieldsEl.classList.remove('is-error');
    });

    form.addEventListener('nl:subscribed', showSuccess);
  }

  if (feedbackEl) {
    const observer = new MutationObserver(function () {
      if (feedbackEl.dataset.state === 'error') {
        submitBtn.classList.remove('is-submitting');
        if (fieldsEl) fieldsEl.classList.add('is-error');
        if (statusEl) {
          statusEl.textContent = feedbackEl.textContent || 'Something went wrong — please try again.';
          statusEl.classList.add('is-error');
        }
        feedbackEl.textContent = '';
        feedbackEl.removeAttribute('data-state');
      }
    });
    observer.observe(feedbackEl, {childList: true, attributes: true, attributeFilter: ['data-state']});
  }

  renderSelected();
}

function initFooterNl(wrap) {
  const form = wrap.querySelector('form');
  const formSection = wrap.querySelector('[data-fnl-form-section]');
  const formWrap = wrap.querySelector('[data-fnl-wrap]');
  const emailInput = form.querySelector('[name="email"]');
  const btn = form.querySelector('[data-fnl-btn]');
  const errorEl = wrap.querySelector('[data-fnl-error]');
  const errorText = wrap.querySelector('[data-fnl-error-text]');
  const successEl = wrap.querySelector('[data-fnl-success]');
  const emailDisplay = wrap.querySelector('[data-fnl-email-display]');

  function setState(state, msg) {
    formWrap.classList.remove('fnl-form-wrap--submitting', 'fnl-form-wrap--error');
    errorEl.hidden = true;

    if (state === 'submitting') {
      formWrap.classList.add('fnl-form-wrap--submitting');
      emailInput.readOnly = true;
      btn.disabled = true;
      btn.textContent = 'Subscribing…';

    } else if (state === 'success') {
      if (emailDisplay) emailDisplay.textContent = emailInput.value.trim();
      formSection.hidden = true;
      successEl.hidden = false;

    } else if (state === 'error') {
      formWrap.classList.add('fnl-form-wrap--error');
      if (msg && errorText) errorText.textContent = msg;
      errorEl.hidden = false;
      emailInput.readOnly = false;
      btn.disabled = false;
      btn.textContent = 'Subscribe →';

    } else {
      emailInput.readOnly = false;
      btn.disabled = false;
      btn.textContent = 'Subscribe →';
    }
  }

  emailInput.addEventListener('input', function () {
    if (formWrap.classList.contains('fnl-form-wrap--error')) {
      setState('rest');
    }
  });

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setState("error", email === '' ? 'Email is required!' : "That doesn’t look like a valid email. Mind double-checking?");
      return;
    }

    setState("submitting");

    try {
      const res = await fetch(form.action, {method: "POST", body: new FormData(form)});
      if (res.ok) {
        setState("success");
      } else {
        let errMsg = "Something went wrong — please try again.";
        if (res.status === 429) errMsg = "Too many tries — please wait a moment.";
        setState("error", errMsg);
      }
    } catch (_) {
      setState("error", "Network error — please try again.");
    }
  });
}

function initNlDispatch(wrap) {
  const form = wrap.querySelector("form");
  const headerEl = wrap.querySelector(".nw-header");
  const successEl = wrap.querySelector(".nw-success");
  const emailInput = wrap.querySelector(".nw-input");
  const btn = wrap.querySelector(".nw-btn");
  const fieldEl = wrap.querySelector(".nw-field");
  const errorEl = wrap.querySelector(".nw-error");
  const errorTxt = errorEl ? errorEl.querySelector("span") : null;
  const emailDisplay = successEl ? successEl.querySelector("strong") : null;

  function setError(msg) {
    if (fieldEl) fieldEl.classList.add("nw-field--error");
    if (errorTxt) errorTxt.textContent = msg;
    if (errorEl) errorEl.style.display = "block";
    if (btn) {
      btn.disabled = false;
      btn.textContent = "Subscribe →";
    }
  }

  function clearError() {
    if (fieldEl) fieldEl.classList.remove("nw-field--error");
    if (errorEl) errorEl.style.display = "none";
  }

  if (emailInput) {
    emailInput.addEventListener("input", function () {
      if (fieldEl && fieldEl.classList.contains("nw-field--error")) clearError();
    });
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    const email = emailInput ? emailInput.value.trim() : "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      setError("That doesn’t look like a valid email.");
      if (emailInput) emailInput.focus();
      return;
    }
    clearError();
    const fd = new FormData(form);
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Subscribing…";
    }
    try {
      const res = await fetch(form.action, {method: "POST", body: fd});
      if (res.ok) {
        if (emailDisplay) emailDisplay.textContent = email;
        if (headerEl) headerEl.style.display = "none";
        if (form) form.style.display = "none";
        if (successEl) successEl.style.display = "block";
      } else {
        let msg = "Something went wrong — please try again.";
        if (res.status === 429) {
          msg = "Too many tries — please wait a moment.";
        }
        setError(msg);
      }
    } catch (_) {
      setError("Network error — please check your connection.");
    }
  });
}

function initNlDetail(wrap) {
  const form = wrap.querySelector('form');
  const contentEl = wrap.querySelector('[data-ndl-content]');
  const successEl = wrap.querySelector('[data-ndl-success]');
  const emailInput = wrap.querySelector('[data-ndl-email]');
  const btn = wrap.querySelector('[data-ndl-btn]');
  const fieldEl = wrap.querySelector('[data-ndl-wrap]');
  const errorEl = wrap.querySelector('[data-ndl-error]');
  const errorTxt = wrap.querySelector('[data-ndl-error-text]');
  const emailDisplay = wrap.querySelector('[data-ndl-email-display]');

  function setState(state, msg) {
    fieldEl.classList.remove('ndl-card-field--error');
    errorEl.hidden = true;

    if (state === 'submitting') {
      emailInput.disabled = true;
      btn.disabled = true;
      btn.textContent = 'Subscribing…';

    } else if (state === 'success') {
      if (emailDisplay) emailDisplay.textContent = emailInput.value.trim();
      contentEl.hidden = true;
      successEl.hidden = false;

    } else if (state === 'error') {
      fieldEl.classList.add('ndl-card-field--error');
      if (msg && errorTxt) errorTxt.textContent = msg;
      errorEl.hidden = false;
      emailInput.disabled = false;
      btn.disabled = false;
      btn.textContent = 'Subscribe →';

    } else {
      emailInput.disabled = false;
      btn.disabled = false;
      btn.textContent = 'Subscribe →';
    }
  }

  emailInput.addEventListener('input', function () {
    if (fieldEl.classList.contains('ndl-card-field--error')) setState('rest');
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const email = emailInput.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      setState('error', email === '' ? 'Email is required!' : "That doesn't look like a valid email. Mind double-checking?");
      emailInput.focus();
      return;
    }
    const fd = new FormData(form);
    setState('submitting');
    try {
      const res = await fetch(form.action, {method: 'POST', body: fd});
      if (res.ok) {
        setState('success');
      } else {
        let errMsg = 'Something went wrong — please try again.';
        if (res.status === 429) {
          errMsg = 'Too many tries — please wait a moment.';
        }
        setState('error', errMsg);
      }
    } catch (_) {
      setState('error', 'Network error — please check your connection.');
    }
  });
}

function subscribeNl(form) {
  const btn = form.querySelector('[type="submit"]');
  const feedbackEl = form.querySelector('[data-nl-feedback]');
  const emailInput = form.querySelector('[name="email"]');
  const typesInput = form.querySelector('[name="types"]');
  const originalText = btn ? btn.textContent : '';

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const email = emailInput ? emailInput.value.trim() : '';
    if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
      if (feedbackEl) {
        feedbackEl.textContent = "That doesn't look like a valid email.";
        feedbackEl.dataset.state = 'error';
      }
      emailInput.focus();
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Subscribing\u2026';
    }
    if (feedbackEl) {
      feedbackEl.textContent = '';
      feedbackEl.removeAttribute('data-state');
    }

    try {
      const res = await fetch(form.action, {method: 'POST', body: new FormData(form)});

      if (res.ok) {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        if (feedbackEl) {
          feedbackEl.textContent = "You\u2019re in! Check your inbox.";
          feedbackEl.dataset.state = 'success';
        }
        if (emailInput) emailInput.value = '';
        if (typesInput) typesInput.value = '';
        form.dispatchEvent(new CustomEvent('nl:subscribed', {
          bubbles: true,
          detail: {email: email}
        }));
      } else {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        if (feedbackEl) {
          feedbackEl.textContent = 'Something went wrong \u2014 please try again.';
          feedbackEl.dataset.state = 'error';
        }
      }
    } catch (_) {
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalText;
      }
      if (feedbackEl) {
        feedbackEl.textContent = 'Network error \u2014 please try again.';
        feedbackEl.dataset.state = 'error';
      }
    }
  });
}
